import { Node, Text } from "html-react-parser";

export const nodeIsText = (input: Node): input is Text => input.type === "text";
